import state from './moduleBasicUserState.js';
import mutations from './moduleBasicUserMutations.js';
import actions from './moduleBasicUserActions.js';
import getters from './moduleBasicUserGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
